// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"241":"0cf2b99d","334":"3010002c"}[chunkId] + ".chunk.css";
};